
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.5 1h-2l-.62 4H7.5V1zM10.5 1h-2v4h2.62l-.62-4zM3.5 14h4V8H4.42l-.92 6zM8.5 8v6h4l-.92-6H8.5zM14 5.5H2a1 1 0 00-1 1 .5.5 0 00.5.5H2a.5.5 0 001 0h10a.5.5 0 001 0h.5a.5.5 0 00.5-.5 1 1 0 00-1-1z"}})])])
          )
        }
      }
    